<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">
            <!-- 序号 -->
            <el-table-column align="left" label="序号" width="60px">
            <template slot-scope="scope">
                <span>{{ scope.row.no}}</span>
            </template>
            </el-table-column>

            <!-- 险种 -->
            <el-table-column align="left" label="险种" width="180px">
            <template slot-scope="scope">
                <span>{{ scope.row.insruance_type }}</span>
            </template>
            </el-table-column>

            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" width="220px">
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span>{{ scope.row.policy_number }}</span>
            </template>
            </el-table-column>

            <!-- 保费金额 -->
            <el-table-column align="left" label="保费金额" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 不含税保费 -->
            <el-table-column align="left" label="不含税保费" width="120px">
            <template slot-scope="scope">
                <span>{{ scope.row.tax_free_premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 手续费率 -->
            <el-table-column align="left" label="手续费率" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 不含税保费 -->
            <el-table-column align="left" label="不含税保费" width="120px">
            <template slot-scope="scope">
                <span>{{ scope.row.tax_free_commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 增值税-->
            <el-table-column align="left" label="增值税" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.vat | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 手续费金额-->
            <el-table-column align="left" label="手续费金额" width="120px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 投保人 -->
            <el-table-column align="left" label="投保人" >
            <template slot-scope="scope">
                <span>{{ scope.row.policy_holder }}</span>
            </template>
            </el-table-column>

            <!-- 被保险人 -->
            <el-table-column align="left" label="被保险人" >
            <template slot-scope="scope">
                <span>{{ scope.row.insured}}</span>
            </template>
            </el-table-column>

            <!-- 手续费支付对象 -->
            <el-table-column align="left" label="手续费支付对象" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_receiver}}</span>
            </template>
            </el-table-column>

            <!-- 核保时间 -->
            <el-table-column align="left" label="核保时间" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.underwriting_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 起保时间 -->
            <el-table-column align="left" label="起保时间" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.insurance_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 实收时间 -->
            <el-table-column align="left" label="实收时间" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.paid_time | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-yong-cheng',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
